import script from "./LeadsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsTable.vue?vue&type=script&setup=true&lang=js"

import "./LeadsTable.vue?vue&type=style&index=0&id=09164154&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09164154"]])

export default __exports__